export default "/dist/fonts/Exo2-Regular.ttf";